import { Item } from "@/domain/contracts";
import { CrashInput } from "@/domain/dtos/inputs";
import { ApiQuery, ApiService } from "@/domain/clients";
import { Endpoints } from "@/infra/api";
import { SettingsDataSource } from "./SettingsDataSource";
import { NotFoundError } from "@/domain";

export class SettingsRemoteDataSource implements SettingsDataSource {
  constructor(private readonly api: ApiService) {}

  getTermsOfUse(): Promise<any> {
    return this.api.get(Endpoints.terms_of_use);
  }

  async getTermsOfUsePsi(): Promise<string> {
    const { data } = await this.api.get<string>(Endpoints.terms_of_use_psi);

    if (!data) throw new NotFoundError();

    return data;
  }

  getPrivacyPolicy(): Promise<any> {
    return this.api.get(Endpoints.privacy_policy);
  }

  reportCrash(params: CrashInput): Promise<any> {
    return this.api.post(Endpoints.app_crashes, params);
  }

  async getLanguages(): Promise<any> {
    const { data } = await this.api.get(Endpoints.languages);

    if (!data) return [];

    return data;
  }

  async getOccupationAreas(query?: ApiQuery): Promise<Item[]> {
    const { data } = await this.api.get<Item[]>(
      Endpoints.occupation_areas,
      query,
    );

    if (!data) return [];

    return data;
  }

  async getApproaches(query?: ApiQuery): Promise<Item[]> {
    const { data } = await this.api.get<Item[]>(Endpoints.approaches, query);

    if (!data) return [];

    return data;
  }
}
